import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import styles from './style.module.css';

interface CancelAndRescheduleProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function CancelAndReschedule({
  open,
  onOpenChange,
}: CancelAndRescheduleProps) {
  const [cancelOption, setCancelOption] = useState('doctor');
  const [description, setDescription] = useState('');

  console.log({ cancelOption });

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Overlay className="fixed inset-0 bg-black/30" />
      <Dialog.Content className="fixed inset-0 flex items-center justify-center p-4">
        <div className="bg-[#fff] rounded-lg max-w-md w-full p-6 relative">
          <Dialog.Title className="text-xl font-bold mb-4">
            Cancel and Reschedule
          </Dialog.Title>
          <Dialog.Close asChild>
            <button className="absolute top-4 right-4 text-gray-500 hover:text-gray-700">
              <X />
            </button>
          </Dialog.Close>

          <p className="mb-6">
            This will cancel the appointment and let the user either create a
            free-of-charge (FOC) reschedule or get a refund.
          </p>

          <Select>
            <SelectTrigger
              className={`${styles['manage-booking-dropdown-outline']} w-[250px]`}
            >
              <SelectValue placeholder="Cancelled by" />
            </SelectTrigger>
            <SelectContent className="z-[9999]">
              {[
                { value: 'doctor', label: 'Cancelled by Doctor' },
                { value: 'patient', label: 'Cancelled by Patient' },
                { value: 'system', label: 'Cancelled by System' },
              ].map(({ value, label }, index) => (
                <SelectItem
                  onChange={() => setCancelOption(value)}
                  value={value}
                  key={`select-dropdown-${value}-${index}`}
                >
                  {label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>

          <div className="mb-4 mt-4">
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter description"
              className="w-full p-2 border rounded-lg"
              rows={4}
            />
          </div>

          <div className="flex justify-end">
            <Button variant="black">Confirm</Button>
          </div>
        </div>
      </Dialog.Content>
    </Dialog.Root>
  );
}
